import ContactUs from 'components/layout/footer/ContactUs';
import FooterMain from 'components/layout/footer/FooterMain';
import HeaderNavigation from 'components/layout/header/HeaderNavigation';
import React from 'react';
import LegalSection from 'layouts/section/LegalSection'



const LegalPage: React.FC = () => (
  <div>
    <HeaderNavigation theme='dark'/>
    <LegalSection />
    <ContactUs/>
    <FooterMain/>

    
  </div>
);

export default LegalPage;